import React from "react";
import style from "../../DetailContainer.module.scss";
import { copyToClipboard } from "../../../../utility";
import { MdOutlineContentCopy } from "react-icons/md";
import { BiBuilding, BiCalendar, BiInfoCircle } from "react-icons/bi";
import { TbBriefcase2 } from "react-icons/tb";
import { IoLocationOutline } from "react-icons/io5";
import ExperienceCard from "./ExperienceCard";

function Summary({ candidateData = {}, isLead }) {
  console.log(candidateData, "candidateData" ,candidateData?.totalYearsOfExp);


  const labels = {
    basicDetails: [
      "Full\u00A0Name",
      "First\u00A0Name",
      "Last\u00A0Name",
      // "ID Number",
      "Gender",
      "Education\u00A0Qualification",
      "Specialization",
      "Applying\u00A0Position",
      "Current\u00A0Company",
      // "Current \u00A0Position",
      // "Native\u00A0Location",
    ],
    basicDetails1: [
      "Current\u00A0Location",
      "Preferred\u00A0Location",
      "Date\u00A0of\u00A0Birth\u00A0&\u00A0Age",
      "Phone\u00A0Number",
      "WhatsApp\u00A0Number",
      "Email\u00A0Address",
      "Guardian\u00A0Name",
      "Guardian\u00A0Number",
      // "Full\u00A0Address",
    ],
    logDetails: [
      "Source\u00A0From",
      "Created\u00A0on",
      `${isLead ? "Last\u00A0Enquiry\u00A0On" : "Registered\u00A0on"}`,
      "Resume\u00A0Added\u00A0On",
    ],
    logDetails1: [
      "Created\u00A0by",
      "Assigned\u00A0by",
      "Assigned\u00A0to",
      "Last\u00A0Updated",
    ],
    additionalInfo: [
      // "Martial\u00A0Status",
      // "Nationality",
      "Currently\u00A0Working",
      "Current\u00A0Industry",
      // "Current\u00A0Department",
      "Employment\u00A0type",
      "Working\u00A0Hours",
    ],
    additionalInfo1: [
      "Current\u00A0Salary",
      "Expected\u00A0Salary",
      "Notice\u00A0Period",
      // "Preferred\u00A0Shift",
      // "Preferred\u00A0Working\u00A0Hours",
      // "Languages\u00A0Known ",
      "Job\u00A0Change\u00A0reason",
    ],
  };

  const keys = {
    basicDetails: [
      "fullName",
      "firstName",
      "lastName",
      // "idNumber",
      "gender",
      "education",
      // "specialization+-+passedOutYear",
      "specialization",
      "position",
      "currentCompany",
      // "currentPosition",
      // "nativeLocation",
    ],
    basicDetails1: [
      "currentLocation",
      "preferredLocation",
      "dob+age",
      "phone",
      "whatsapp",
      "email",
      "guardianName",
      "guardianPhone",
      // "address",
    ],
    logDetails: ["sourceFrom", "entryOn", "createdOn", "resumeAddedOn"],
    logDetails1: [
      "createdBy",
      "assignedTo",
      "assigned_user_name",
      "lastUpdated",
    ],
    additionalInfo: [
      // "maritalStatus",
      // "nationality",
      "currentlyWorking",
      "currentIndustry",
      // "currentDepartment",
      // "department",
      "employmentType",
      "workingHours",
    ],
    additionalInfo1: [
      "currentSalary",
      "expectedSalary",
      "noticePeriod",
      // "preferredShift",
      // "workingHours",
      // "languagesKnown",
      "jobChangeReason",
    ],
  };

  const copyFields = [
    "fullName",
    "idNumber",
    "phone",
    "whatsapp",
    "email",
    "guardianPhone",
  ];

  // console.log(candidateData?.totalYearsOfExp,"candidateData?.totalYearsOfExp");

  return (
    <>
      <div className={style.CandidateDetailSummarycontainer}>
        <div className="d-flex flex-column gap-2">
          <div className={style.CandidateDetailsContainer}>
            <div className={style.CandidateDetailsHeader}>
              <div className={style.CandidateDetailstitle}>
                Candidate Details
              </div>
            </div>

            <div className={style.CandidateDetailsBodyConatiner}>
              <div className={style.BasicDetails}>
                <div className={style.line1}>
                  {labels.basicDetails.map((label, i) => (
                    <span key={i}>{label}</span>
                  ))}
                </div>

                <div className={style.line1}>
                  {labels.basicDetails.map((_, i) => (
                    <span key={i}>:</span>
                  ))}
                </div>

                <div className={style.line1}>
                  {keys.basicDetails.map((key, i) => (
                    <span
                      key={i}
                      className={
                        copyFields.includes(key)
                          ? style.line_content1
                          : style.line_content
                      }
                    >
                      {candidateData[key] || "N/A"}{" "}
                      {copyFields.includes(key) && candidateData[key] && (
                        <MdOutlineContentCopy
                          onClick={() => copyToClipboard(candidateData[key])}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </span>
                  ))}
                </div>
              </div>
              <div className={style.BasicDetails}>
                <div className={style.line1}>
                  {labels.basicDetails1.map((label, i) => (
                    <span key={i}>{label}</span>
                  ))}
                </div>
                <div className={style.line1}>
                  {labels.basicDetails1.map((_, i) => (
                    <span className="" key={i}>
                      :
                    </span>
                  ))}
                </div>{" "}
                <div className={style.line1}>
                  {keys.basicDetails1.map((key, i) => (
                    <span
                      key={i}
                      className={
                        copyFields.includes(key)
                          ? style.line_content1
                          : style.line_content
                      }
                    >
                      {key === "dob+age" ? (
                        <>
                          {candidateData.dob || "N/A"} &{" "}
                          {candidateData.age || "N/A"}
                        </>
                      ) : (
                        candidateData[key] || "N/A"
                      )}{" "}
                      {copyFields.includes(key) && candidateData[key] && (
                        <MdOutlineContentCopy
                          onClick={() => copyToClipboard(candidateData[key])}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={style.CandidateDetailsSection}>
          <div className={style.CandidateDetailsHeader}>
            <div className={style.CandidateDetailstitle}>Key Skills</div>
            {/*  */}
          </div>
          <div className={style.CandidateDetailsBodyConatiner}>
            <div>
              {candidateData?.keySkill &&
              candidateData.keySkill.trim() !== "" ? (
                <div className={style.skillsdata}>
                  {candidateData.keySkill
                    .split(",")
                    .filter((s) => s.trim() !== "") // remove empty values
                    .map((skill, index) => (
                      <div key={index} className={style.keySkills}>
                        {skill.trim()}
                      </div>
                    ))}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                  className={style.NoDataStyle}
                >
                  No key skills listed
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={style.CandidateDetailsWorkExperience}>
          <div className={style.CandidateDetailsHeader}>
            <div className={style.CandidateDetailstitle}>Work Experience</div>
          </div>
          <div className={style.CandidateDetailsBodyConatiner}>
          {isLead ? (
            // ✅ LEAD LOGIC
            candidateData?.totalYearsOfExp === "0.0 years EXP" ? (
              <div className={style.NoDataStyle}>
                This Candidate is Fresher
              </div>
            ) : (
              <ExperienceCard
                position={candidateData?.position}
                exp={candidateData?.totalYearsOfExp}
                company={candidateData?.companyName}
                industry={candidateData?.currentIndustry}
                dept={candidateData?.currentDepartment}
                location={candidateData?.companyLocation}
              />
            )
          ) : (candidateData?.candidate_type ==="Fresher") ? (
            // ✅ REGISTERED FRESHER
            <div className={style.NoDataStyle}>
              This Candidate is Fresher
            </div>
          ) : (
            // ✅ REGISTERED EXPERIENCED
            <ExperienceCard
              position={candidateData?.position}
              exp={candidateData?.totalYearsOfExp}
              company={candidateData?.companyName}
              industry={candidateData?.currentIndustry}
              dept={candidateData?.currentDepartment}
              location={candidateData?.companyLocation}
            />
          )}
        </div>
        </div>
        <div className={style.CandidateDetailsLogBookContainer}>
          <div className={style.CandidateDetailsHeader}>
            <div className={style.CandidateDetailstitle}>
              Additional Information
            </div>
          </div>

          <div className={style.CandidateDetailsBodyConatiner}>
            <div className={style.BasicDetails}>
              <div className={style.line1}>
                {labels.additionalInfo.map((label, i) => (
                  <span key={i}>{label}</span>
                ))}
              </div>

              <div className={style.line1}>
                {labels.additionalInfo.map((_, i) => (
                  <span key={i}>:</span>
                ))}
              </div>

              <div className={style.line1}>
                {keys.additionalInfo.map((key, i) => (
                  <span
                    key={i}
                    className={
                      copyFields.includes(key)
                        ? style.line_content1
                        : style.line_content
                    }
                  >
                    {candidateData[key] || "N/A"}
                    {copyFields.includes(key) && candidateData[key] && (
                      <MdOutlineContentCopy
                        onClick={() => copyToClipboard(candidateData[key])}
                      />
                    )}
                  </span>
                ))}
              </div>
            </div>
            <div className={style.BasicDetails}>
              <div className={style.line1}>
                {labels.additionalInfo1.map((label, i) => (
                  <span key={i}>{label}</span>
                ))}
              </div>

              <div className={style.line1}>
                {labels.additionalInfo1.map((_, i) => (
                  <span key={i}>:</span>
                ))}
              </div>

              <div className={style.line1}>
                {keys.additionalInfo1.map((key, i) => (
                  <span
                    key={i}
                    className={
                      copyFields.includes(key)
                        ? style.line_content1
                        : style.line_content
                    }
                  >
                    {candidateData[key] || "N/A"}
                    {copyFields.includes(key) && candidateData[key] && (
                      <MdOutlineContentCopy
                        onClick={() => copyToClipboard(candidateData[key])}
                      />
                    )}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className={`${style.CandidateDetailsLogBookContainer} mb-3`}>
          <div className={style.CandidateDetailsHeader}>
            <div className={style.CandidateDetailstitle}>Log Book</div>
            <div className={style.CandidateDetailIcons}>
              <span>
                <BiInfoCircle />
              </span>
            </div>
          </div>

          <div className={style.CandidateDetailsBodyConatiner}>
            <div className={style.BasicDetails}>
              <div className={style.line1}>
                {labels.logDetails.map((label, i) => (
                  <span key={i}>{label}</span>
                ))}
              </div>

              <div className={style.line1}>
                {labels.logDetails.map((_, i) => (
                  <span key={i}>:</span>
                ))}
              </div>

              <div className={style.line1}>
                {keys.logDetails.map((key, i) => (
                  <span
                    key={i}
                    className={
                      copyFields.includes(key)
                        ? style.line_content1
                        : style.line_content
                    }
                  >
                    {candidateData[key] || "N/A"}
                    {copyFields.includes(key) && candidateData[key] && (
                      <MdOutlineContentCopy
                        onClick={() => copyToClipboard(candidateData[key])}
                      />
                    )}
                  </span>
                ))}
              </div>
            </div>
            <div className={style.BasicDetails}>
              <div className={style.line1}>
                {labels.logDetails1.map((label, i) => (
                  <span key={i}>{label}</span>
                ))}
              </div>

              <div className={style.line1}>
                {labels.logDetails1.map((_, i) => (
                  <span key={i}>:</span>
                ))}
              </div>

              <div className={style.line1}>
                {keys.logDetails1.map((key, i) => (
                  <span
                    key={i}
                    className={
                      copyFields.includes(key)
                        ? style.line_content1
                        : style.line_content
                    }
                  >
                    {candidateData[key] || "N/A"}
                    {copyFields.includes(key) && candidateData[key] && (
                      <MdOutlineContentCopy
                        onClick={() => copyToClipboard(candidateData[key])}
                      />
                    )}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Summary;
